$(function(){
    //formareaのみ実行
    if($('.formarea').length){
        //離脱の警告
        $(window).on('beforeunload', function() {
            return 'フォームは未送信です。\n' +
                'このままページを移動するとフォームに入力したデータは保存されません。';
        });
        $('.js-no-withdrawal').on('click', function(e) {
            $(window).off('beforeunload');
        });
        // カタ自動補完
        $.fn.autoKana('.name', '.kana', {
            katakana : true  //true：カタカナ、false：ひらがな（デフォルト）
        });
    }
});